import { matchPath } from 'react-router-dom';
import { ROUTES } from './routes';

/**
 * Document title for every route: "<page> | <tenant name>", e.g. "Sign In | Acme Careers".
 * Flutter shows MaterialApp(title: contentSettings.general.name) on every page, so every tab read
 * the same; here each route names its page, and the tenant name still follows.
 *
 * Page names are Flutter's existing English texts (translation keys) where one fits, so they come
 * out in the tenant's language. A page with a title of its own (the job title on /jobs/:id) sets
 * it with usePageTitle. Rendered once at the router root, so client-side navigation, deep links
 * and a refresh all set it.
 */
const ROUTE_TITLES: [pattern: string, title: string][] = [
  [ROUTES.HOME, 'Jobs'],
  [ROUTES.LOGIN, 'Sign In'],
  [ROUTES.SIGN_UP, 'Create your account'],
  [ROUTES.JOBS, 'Explore Jobs'],
  [ROUTES.JOBS_DETAIL, 'Job Details'],
  [ROUTES.SAVED_JOBS, 'Saved Jobs'],
  [ROUTES.EXTRACTED_RESUME, 'Extracted from your resume'],
  [ROUTES.CANDIDATE_FORM, 'Application Form'],
  [ROUTES.APPLICATION, 'Application Form'],
  [ROUTES.APPLICATION_WITH_ID, 'Application Form'],
  [ROUTES.EASY_APPLY, 'Easy Apply'],
  [ROUTES.EASY_APPLY_WITH_ID, 'Easy Apply'],
  [ROUTES.PROFILE, 'Profile'],
  [ROUTES.EDIT_PROFILE, 'Edit Profile'],
  [ROUTES.VIEW_JOBS, 'My Jobs'],
  [ROUTES.VIEW_JOBS_APPLIED, 'My Jobs'],
  [ROUTES.VIEW_JOBS_INVITED, 'Invited Jobs'],
  [ROUTES.VIEW_JOBS_RECOMMENDED, 'Recommended Jobs'],
  [ROUTES.VIEW_JOBS_SAVED, 'Saved Jobs'],
  [ROUTES.RESET_PASSWORD, 'Reset Password'],
  [ROUTES.VERIFY_EMAIL, 'Verify Email'],
  [ROUTES.EMAIL_VERIFIED, 'Email Verified!'],
  [ROUTES.DUPLICATE_ACCOUNT, 'Duplicate Account'],
  [ROUTES.MFA, 'Multi-Factor Authentication'],
  [ROUTES.ABOUT_US, 'About Us'],
  [ROUTES.JOB_APPLICATION, 'Application Form'],
  [ROUTES.ONBOARDING, 'Onboarding Form'],
];

/** The default (untranslated) page name for a path, if the route has one. */
export function routePageTitle(pathname: string): string | undefined {
  return ROUTE_TITLES.find(([pattern]) => matchPath({ path: pattern, end: true }, pathname))?.[1];
}

export function formatDocumentTitle(page: string | undefined, brand: string): string {
  if (page && brand) return `${page} | ${brand}`;
  return page || brand;
}
